import React from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import PhoneFieldComponent from 'brandComponents/Form/Subcomponents/PhoneField';
import {IPhoneFieldProps} from 'brandComponents/Form/Subcomponents/PhoneField/IPhoneField';
import Icon from 'brandComponents/Icon';

import messages from './messages';

import styles from './PhoneField.module.scss';

const PhoneField = ({
	classNames,
	isRequired = false,
	...props
}: IPhoneFieldProps) => {
	const intl = useIntl();

	const DropdownIcon = <Icon classNames={styles['auth__register-form__fields--icon']} name="arrow-down" width={20} height={20} />;

	return (
		<PhoneFieldComponent
			name="phone"
			placeholder={intl.formatMessage(messages.phoneLabel)}
			label={intl.formatMessage(messages.phoneLabel)}
			showElement={{label: true, tip: false}}
			isRequired={isRequired}
			classNames={cn(styles['phone-field'], classNames)}
			customIcon={DropdownIcon}
			{...props}
		/>
	);
};

export default PhoneField;
